import { base } from '../base';

export const baseODATA = 'gateway/mainodata';

export const facebookPost = `${base}/FacebookPost`;
export const getFacebookPostODATA = `${baseODATA}/facebookpostsearchquery`;
